var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGl71(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3319_9899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8037 25.1965L36.3268 7.65799C36.3268 7.65799 40.5548 3.56095 44.259 7.2651L54.0618 23.8869",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5047 41.8984L37.8109 31.3984V31.3109H31.6297V29.0984H40.6109V31.3422L35.2984 41.8984H32.5047ZM48.0344 29.0984V41.8984H45.3281V31.6672H45.2531L42.3219 33.5047V31.1047L45.4906 29.0984H48.0344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4125 69.3375C38.325 69.0333 38.2021 68.7646 38.0438 68.5312C37.8854 68.2937 37.6917 68.0937 37.4625 67.9312C37.2375 67.7646 36.9792 67.6375 36.6875 67.55C36.4 67.4625 36.0813 67.4187 35.7313 67.4187C35.0771 67.4187 34.5021 67.5812 34.0063 67.9062C33.5146 68.2312 33.1313 68.7042 32.8563 69.325C32.5813 69.9417 32.4438 70.6958 32.4438 71.5875C32.4438 72.4792 32.5792 73.2375 32.85 73.8625C33.1208 74.4875 33.5042 74.9646 34 75.2937C34.4958 75.6187 35.0813 75.7812 35.7563 75.7812C36.3688 75.7812 36.8917 75.6729 37.325 75.4562C37.7625 75.2354 38.0958 74.925 38.325 74.525C38.5583 74.125 38.675 73.6521 38.675 73.1062L39.225 73.1875H35.925V71.15H41.2813V72.7625C41.2813 73.8875 41.0438 74.8542 40.5688 75.6625C40.0938 76.4667 39.4396 77.0875 38.6063 77.525C37.7729 77.9583 36.8188 78.175 35.7438 78.175C34.5438 78.175 33.4896 77.9104 32.5813 77.3812C31.6729 76.8479 30.9646 76.0917 30.4563 75.1125C29.9521 74.1292 29.7 72.9625 29.7 71.6125C29.7 70.575 29.85 69.65 30.15 68.8375C30.4542 68.0208 30.8792 67.3292 31.425 66.7625C31.9708 66.1958 32.6063 65.7646 33.3313 65.4687C34.0563 65.1729 34.8417 65.025 35.6875 65.025C36.4125 65.025 37.0875 65.1312 37.7125 65.3437C38.3375 65.5521 38.8917 65.8479 39.375 66.2312C39.8625 66.6146 40.2604 67.0708 40.5688 67.6C40.8771 68.125 41.075 68.7042 41.1625 69.3375H38.4125ZM43.3141 78V65.2H46.0203V75.7687H51.5078V78H43.3141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2564 55.9971L16.8061 55.6531C16.8061 55.6531 11.1439 54.04 12.4997 48.9801L21.9932 32.1797",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2048 30.6758L68.1321 48.5583C68.1321 48.5583 69.5662 54.2684 64.5063 55.6242L45.21 55.8028",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3418 55.8543L49.0777 48.9414V62.5529L37.3418 55.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 32.2137L26.0387 25.3008V38.9123L14.3027 32.2137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3223 23.9872L58.0582 17.0742V30.6857L46.3223 23.9872Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3319_9899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGl71);
export default __webpack_public_path__ + "static/media/gl71.048d669c382d2cea69c928a4e9e9cf2b.svg";
export { ForwardRef as ReactComponent };